// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__uY8CG","notes":"Notes_notes__2D4TB"};